import styled from 'styled-components';
import {
  compose,
  ColorProps,
  FlexboxProps,
  LayoutProps,
  PositionProps,
  SpaceProps,
  color,
  flexbox,
  layout,
  position,
  space,
  BackgroundImageProps,
  backgroundImage,
} from 'styled-system';
import { backgroundImageTheme } from '../shared/BackgroundImageTheme';

type Props = LayoutProps & PositionProps & SpaceProps & FlexboxProps & ColorProps & BackgroundImageProps;

export const HeaderContainer = styled.header<Props>(
  compose(layout, position, space, flexbox, color, backgroundImage, backgroundImageTheme)
);
